(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "CashlessPaymentRefundViewModel",
      cashlessPaymentRefundViewModelFactory
    );

  /** @ngInject */
  function cashlessPaymentRefundViewModelFactory($translate, DateTime) {
    function CashlessPaymentRefundViewModel() {
      this.cashlessPaymentAndRefundList = [];
      this.filter = "";
      this.since = 0;
      this.until = 0;

      // GRID CONFIG
      this.orderBy = "timestamp";
      this.order = "desc";
      this.page = 1;
      this.total = 0;
      this.pageSize = 20;
      this.pageOptions = [5, 10, 20, 50];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.since = new Date(
          new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.until = new Date(
          new DateTime().endOf(DateTime.units.DAY).timestamp
      );
      this.totalAmount = 0;
      this.totalNetAmount = 0;
    }

    CashlessPaymentRefundViewModel.prototype.destroy = function () {};

    CashlessPaymentRefundViewModel.prototype.cashlessPaginationChanged = function(page, limit) {
      this.page = page;
      this.pageSize = limit;
    };

    CashlessPaymentRefundViewModel.prototype.cashlessOrderingChanged = function(order) {
      var orderQuery = getOrderObject(order);
      this.orderBy = orderQuery.orderBy;
      this.order = orderQuery.order;
    };

    CashlessPaymentRefundViewModel.prototype.refresh = function (data) {
      this.cashlessPaymentAndRefundList = [];
      if (data.content.length === 0) {
        this.cashlessPaymentAndRefundList.push({
          user: $translate.instant("NOTHING_TO_DISPLAY"),
          hideButton: true
        });
        return;
      }
      this.cashlessPaymentAndRefundList = data.content;
      this.total = data.totalElements;
    };

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return CashlessPaymentRefundViewModel;
  }
})();
